import { Link } from "react-router-dom";
import logoOriginal from "@/assets/logo-original.svg";
import { BRAND } from "@garageregister/shared";

export function MarketingFooter() {
  return (
    <footer className="border-t border-[#253448] bg-[#0C1222]">
      <div className="mx-auto max-w-6xl px-4 py-12 sm:px-6 lg:px-8">
        <div className="grid gap-8 md:grid-cols-4">
          <div className="md:col-span-2">
            <Link to="/">
              <img src={logoOriginal} alt={BRAND.name} className="h-12" />
            </Link>
            <p className="mt-3 max-w-sm text-sm text-[#7A8FA3]">
              {BRAND.tagline} The vehicle tracker built for enthusiasts who care about every bolt, every mile, every mod.
            </p>
          </div>

          <div>
            <h4 className="mb-3 text-sm font-semibold text-[#E8EDF2]">Product</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="/#features" className="text-[#7A8FA3] transition-colors hover:text-[#E8EDF2]">
                  Features
                </a>
              </li>
              <li>
                <Link to="/pricing" className="text-[#7A8FA3] transition-colors hover:text-[#E8EDF2]">
                  Pricing
                </Link>
              </li>
              <li>
                <Link to="/signup" className="text-[#7A8FA3] transition-colors hover:text-[#E8EDF2]">
                  Sign Up
                </Link>
              </li>
              <li>
                <Link to="/signin" className="text-[#7A8FA3] transition-colors hover:text-[#E8EDF2]">
                  Sign In
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="mb-3 text-sm font-semibold text-[#E8EDF2]">Legal</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/privacy" className="text-[#7A8FA3] transition-colors hover:text-[#E8EDF2]">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-[#7A8FA3] transition-colors hover:text-[#E8EDF2]">
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 border-t border-[#253448] pt-6 text-center text-xs text-[#4A5C6F]">
          &copy; {new Date().getFullYear()} {BRAND.name}. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
